import React, { useState, useEffect, useRef } from 'react'

import { Button, Dialog, Grid, Icon, Typography, FormHelperText } from '@material-ui/core'

import Scrollbars from "rc-scrollbars";
import CloseIcon from '@material-ui/icons/Close';
import useStyles from "./styles";
import { Label, DraggableComponent } from '../../../../../components/UiElements/UiElements';
import { withSnackbar } from "./../../../../../components/Message/Alert";
import DialogLoader from './../../../../../components/Loader/DialogLoader';
import Rating from '../../../../../components/RatingStars/RatingStars';
function StatusSummary({ dialogOpenClose, handleClose, trackNumberDetails, ...props }) {
    const classes = useStyles();

    var user = sessionStorage.getItem('user_info');
    const [state, setState] = useState({});
    const [isLoading, setIsLoading] = useState(false);

    const ratingsArray = [
        { text: "Financial capacity", value: 3 },
        { text: "Frequency of Giving", value: 2 },
        { text: "Relationship Strength", value: 4.5 },
        { text: "Engagement Level", value: 5 },

        { text: "Interest and Affinity", value: 3.5 },

      ];

    useEffect(() => {
    }, []);

    return (
        <>
            <Dialog
                classes={{ paper: classes.dialogPaper }}
                disableEscapeKeyDown
                open={dialogOpenClose}
                PaperComponent={DraggableComponent}
                maxWidth="md"
                {...props} >
                <div className={classes.activeDialogContent}>
                    <div className={classes.box}>
                        <div className={classes.header} id="draggable-dialog-title">
                            <Typography className={classes.title}>Rate Grantee</Typography>
                            <Icon className={classes.closeIcon} onClick={handleClose} color="primary"><CloseIcon /></Icon>
                        </div>
                        {isLoading ? <DialogLoader></DialogLoader> : ''}
                        <Scrollbars autoHeight autoHeightMax={540}>
                            <div className={classes.content}>
                                <Grid container  row className={classes.Container}>
                                {ratingsArray.map((item, index) => (
                                     <Grid row xl={12} lg={12} md={12} sm={12}>
                                <Rating text={item.text} value={item.value} />
                                </Grid>
                                ))}
                                </Grid>
                            </div>
                        </Scrollbars>
                        <div className={classes.footer}>
                            <div className={classes.footerRight}>
                                <Button className={classes.backBtn} onClick={handleClose}>Cancel</Button>
                            </div>
                        </div>
                    </div>
                </div>
            </Dialog >
        </>
    )
}

export default withSnackbar(StatusSummary);